export const GET_CF3_LIST_START = "[Cf3 Component] Get Cf3 List Start";
export const GET_CF3_LIST_FAIL = "[Cf3 Component] Get Cf3 List Fail";
export const GET_CF3_LIST = "[Cf3 Component] Get Cf3 List";
export const GET_CF3_LIST_SUCCESS = "[Cf3 Component] Get Cf3 List Success";
export const GET_CF3_DETAIL = "[Cf3 Component] Get Cf3 Detail";
export const GET_CF3_DETAIL_SUCCESS = "[Cf3 Component] Get Cf3 Detail Success";
export const CF3_STATUS_ACTION = "[Cf3 Component] Cf3 Status Action";
